import type { PaletteMode } from '@mui/material';
import type { PaletteOptions } from '@mui/material/styles';
import darkPalette from './paletteDark';
import lightPalette from './paletteLight';

export default function createPalette(mode: PaletteMode): PaletteOptions {
  const basePalette = mode === 'light' ? lightPalette : darkPalette;
  return {
    mode, // TODO: why we need that copy of standard theme.palette.mode?
    ...basePalette,
  };
}
